.ProcessRunningModal {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  height: fit-content;
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid #e0e0e0;
  padding: 1rem;
  z-index: 1000;

  h2 {
    text-align: center;
    margin-bottom: 1rem;
  }
}
